import { render, staticRenderFns } from "./EposTransactions.vue?vue&type=template&id=40b2fb24&scoped=true&"
import script from "./EposTransactions.vue?vue&type=script&lang=js&"
export * from "./EposTransactions.vue?vue&type=script&lang=js&"
import style0 from "./EposTransactions.vue?vue&type=style&index=0&id=40b2fb24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b2fb24",
  null
  
)

export default component.exports